import { messages } from '@databases/intl/messages';
import { type DatabaseViewJSON } from '@databases/model/views/view';
import { type DatabaseView } from '@databases/types/database/view';
import type { IntlShape } from 'react-intl-next';

/**
 * Returns true when a given view name is unique among existing view names.
 */
export function isUniqueViewName(name: string, existingViewNames: string[]): boolean {
  return !existingViewNames.some(
    (v) => v.trim().toLowerCase() === name.trim().toLowerCase()
  );
}

/**
 * Returns the view name if it is unique;
 * otherwise appends a number suffix to the view name until it is unique.
 */
export function getUniqueViewName(
  view: DatabaseView | DatabaseViewJSON,
  existingViewNames: string[],
  intl: IntlShape
): string {
  const { formatMessage } = intl;
  const defaultName = formatMessage(messages['view.default-view-name']);

  const viewName = view.name.trim() === '' ? defaultName : view.name;

  let suffix = 1;
  let uniqueName = viewName;

  while (!isUniqueViewName(uniqueName, existingViewNames) || uniqueName === defaultName) {
    uniqueName = `${viewName} ${suffix++}`;
  }

  return uniqueName;
}
